import {
	SET_FORM_STATE,
	GET_FAILURES_VOICE,
	TOGGLE_VOICE_EDIT_FAILURE_DIALOG,
	GET_FAILURE_VOICE_DETAILS,
	GET_FAILURE_VOICE_COMMENTS,
	EXPORT_FAILURES_VOICE,
	TOGGLE_LAYER_3_DIALOG,
	GET_LAYER_3,
	GET_LAYER_3_MESSAGE_MO,
	GET_LAYER_3_MESSAGE_MT,
	GET_LAYER_3_FAILURE,
	GET_LAYER_3_DRIVETEST,
	GET_LAYER_3_KPIS
} from '../actions/VoiceActions';

const initialState = {
	failures: [],
	voiceEditFailureDialogVisibility: false,
	formState: {
		values: {
			failureSource: 'fail'
		},
		isValid: false,
		touched: {},
		errors: {},
	},
	layer3: [],
	layer3Message: '',
	layer3Failure: [],
	layer3DriveTest: [],
	layer3Kpis: [],
	comments: [],
	failuresVoiceFilePath: ''
};

const voiceReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_FAILURES_VOICE: {
						return {
							...state,
							failures: action.failures
						};
					}
					case TOGGLE_VOICE_EDIT_FAILURE_DIALOG: {
						return {
							...state,
							voiceEditFailureDialogVisibility: action.visible,
							tableId: action.tableId,
							filenameMoc: action.filenameMoc,
							filenameMtc: action.filenameMtc,
							failureSide: action.failureSide,
							failureType: action.failureType,
							initialTimestamp: action.initialTimestamp
						};
					}
					case GET_FAILURE_VOICE_DETAILS: {
						return {
							...state,
							failure: action.failure,
							formState: {
								...state.formState,
								values: { ...action.failure.trackerVoiceDetailsDto }
							}
						};
					}
					case GET_FAILURE_VOICE_COMMENTS: {
						return {
							...state,
							comments: action.comments
						};
					}
					case EXPORT_FAILURES_VOICE: {
						return {
							...state,
							failuresVoiceFilePath: action.failuresVoiceFilePath
						};
					}
					case TOGGLE_LAYER_3_DIALOG: {
						return {
							...state,
							layer3DialogVisibility: action.visible,
						};
					}
					case GET_LAYER_3: {
						return {
							...state,
							layer3: action.layer3
						};
					}
					case GET_LAYER_3_MESSAGE_MO: {
						return {
							...state,
							layer3MessageMo: action.layer3MessageMo
						};
					}
					case GET_LAYER_3_MESSAGE_MT: {
						return {
							...state,
							layer3MessageMt: action.layer3MessageMt
						};
					}
					case GET_LAYER_3_FAILURE: {
						return {
							...state,
							layer3Failure: action.layer3Failure
						};
					}
					case GET_LAYER_3_DRIVETEST: {
						return {
							...state,
							layer3DriveTest: action.layer3DriveTest
						};
					}
					case GET_LAYER_3_KPIS: {
						return {
							...state,
							layer3Kpis: action.layer3Kpis
						};
					}
					default: {
						return state;
					}
	}
};

export default voiceReducer;
